import React from 'react';

/**
 * @deprecated, use @ott/icon-chevron-right or @ott/icon-small-chevron-right instead
 */
function DropdownArrowIcon({ w, h, style, fill, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox={`0 0 ${w} ${h}`}
      className={className}
      style={style}
    >
      <polyline strokeWidth="1.2" stroke={fill} points="0,0 7.5,7 15,0" fill="none" />
    </svg>
  );
}

DropdownArrowIcon.defaultProps = {
  w: 15,
  h: 7,
  style: {},
  fill: 'black',
};

DropdownArrowIcon.IS_DEPRECATED = true;

export default DropdownArrowIcon;
